import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

/** Same-origin only: Better Auth uses credentials; cross-origin + * CORS breaks the browser. */
const basePath = "/api/proxy/auth/web";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const authClient: any = createAuthClient({
  baseURL: "",
  basePath,
  plugins: [magicLinkClient()],
});

export { authClient };

export const signOut: typeof authClient.signOut = authClient.signOut;

// NOTE: Do NOT export useSession from Better Auth's client. The app uses
// useWebSession() from WebSessionContext, which calls the custom /compile-session
// endpoint. Better Auth's built-in useSession returns incomplete data.

/** Browser fetches only; use /api/proxy rewrites to the API (see next.config.js). */
export function getApiBaseUrl(): string {
  return "/api/proxy";
}
